import React, { FC } from 'react'
import styles from './Tiles.module.scss'
import Tile from './Tile'
import useQA from 'hooks/useQA'
import { TILES_DATA } from './constants'

const TileList: FC = () => {
  const { testId } = useQA()
  return (
    <div className={styles.tileList} {...testId('tiles-list')}>
      {TILES_DATA.map((tile, index) => (
        <Tile key={index} tile={tile} />
      ))}
    </div>
  )
}

export default TileList
